const elevations = {
    elevation0: '0px 0px 0px #D6D6D6',
    elevation1: '0px 1px 3px #D6D6D6',
    elevation2: '0px 3px 6px #D6D6D6',
    elevation3: '0px 4px 8px #D6D6D6',
    elevation4: '0px 5px 10px #D6D6D6',
    elevation5: '0px 6px 12px #D6D6D6',
    elevation6: '0px 7px 14px #D6D6D6',
    elevation7: '0px 8px 16px #D6D6D6',
    elevation8: '0px 9px 18px #D6D6D6',
    elevation9: '0px 10px 20px #D6D6D6',
    elevation10: '0px 11px 22px #D6D6D6',
};
export default elevations;
//# sourceMappingURL=elevations.js.map